<script setup lang="ts">
import { ref } from 'vue'
import { passwordService } from '@/core/services'
import { flashMessage } from '@/utils/FlashMessages'
import { handleError } from '@/utils/ErrorHandler'
import PasswordInput from '@/components/input/PasswordInput.vue'
import { useStore } from '@/core/store'
import { useRouter } from 'vue-router'
import { popupUtil } from '@/utils/Popup'

const store = useStore()
const router = useRouter()
const currentPassword = ref('')
const newPassword = ref('')
const newPasswordConfirm = ref('')

const submit = async () => {
  const confirmed = await popupUtil.confirm('Are you sure you want to update your password?')
  if (!confirmed) return

  passwordService
    .updatePassword(store.userId, currentPassword.value, newPassword.value, newPasswordConfirm.value, store.getAccessToken())
    .then(() => {
      flashMessage.success('Your password has been updated.')
      router.push('/')
    })
    .catch(handleError)
}
</script>

<template>
  <div class="container">
    <form novalidate>
      <h3>Update password</h3>

      <div class="form-group">
        <PasswordInput
          v-model="currentPassword"
          :name="'currentPassword'"
          :id="'currentPassword'"
          :placeholder="'Current password'"
          :required="true" />

        <PasswordInput v-model="newPassword" :name="'newPassword'" :id="'newPassword'" :placeholder="'New password'" :required="true" />

        <PasswordInput
          v-model="newPasswordConfirm"
          :name="'newPasswordConfirm'"
          :id="'newPasswordConfirm'"
          :placeholder="'Confirm new password'"
          :required="true" />
      </div>

      <button class="submit-button" type="button" @click="submit">Update password</button>
    </form>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/form.scss';
</style>
